import React from "react";

// Pure substring-match highlighter for Global Search result rows. Case-
// insensitive, first-occurrence-only (no fuzzy matching, no multi-match) -
// matches against the free-text portion of the query only (see
// searchOperators.js's parseOperatorTokens), never the raw query string,
// so operator chips like "status:pending" never get highlighted inside a
// structural field.
//
// Returns an array of { text, matched } segments covering the whole string
// in order, so callers can render each segment and wrap only the matched
// one.
export const highlightMatch = (text, query) => {
  const haystack = text === null || text === undefined ? "" : String(text);
  const needle = (query || "").trim();
  if (!haystack || !needle) return [{ text: haystack, matched: false }];

  const idx = haystack.toLowerCase().indexOf(needle.toLowerCase());
  if (idx === -1) return [{ text: haystack, matched: false }];

  const segments = [];
  if (idx > 0) segments.push({ text: haystack.slice(0, idx), matched: false });
  segments.push({ text: haystack.slice(idx, idx + needle.length), matched: true });
  if (idx + needle.length < haystack.length) {
    segments.push({ text: haystack.slice(idx + needle.length), matched: false });
  }
  return segments;
};

// Thin render wrapper around highlightMatch - kept in the same file since
// every call site just wants JSX back, not the raw segment array. Renders
// as a plain fragment when there's no match (or no query yet), so it's safe
// to use unconditionally in place of a bare `{text}`.
export const HighlightText = ({ text, query }) => {
  const segments = highlightMatch(text, query);
  return (
    <>
      {segments.map((segment, index) =>
        segment.matched ? (
          <mark className="global-search__highlight" key={index}>
            {segment.text}
          </mark>
        ) : (
          <React.Fragment key={index}>{segment.text}</React.Fragment>
        )
      )}
    </>
  );
};

export default highlightMatch;
